import { render } from "./fxfcard.vue?vue&type=template&id=507be6b4&scoped=true"
import script from "./fxfcard.vue?vue&type=script&lang=ts"
export * from "./fxfcard.vue?vue&type=script&lang=ts"

import "./fxfcard.vue?vue&type=style&index=0&id=507be6b4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-507be6b4"

export default script